import { Check, Footprints, Hand, Sparkles } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { NewsletterSignup } from "../components/NewsletterSignup";

const POINTS = [
  { icon: Hand, text: "3 gestes simples à faire chez vous, expliqués pas à pas." },
  { icon: Footprints, text: "Un rituel doux pour relâcher les tensions de la journée." },
  { icon: Sparkles, text: "Une première porte d'entrée vers la réflexologie plantaire." },
];

export default function Guide() {
  return (
    <div data-testid="guide-page">
      <section className="pt-32 lg:pt-40 pb-10 px-6 lg:px-12 max-w-4xl mx-auto text-center">
        <Reveal>
          <span className="inline-flex items-center rounded-full bg-gold/90 px-5 py-2 text-xs uppercase tracking-[0.25em] text-olive-dark font-medium">
            Guide offert · gratuit
          </span>
          <h1 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-ink leading-[1.08]">
            3 gestes de réflexologie plantaire à faire chez soi
          </h1>
          <p className="mt-6 text-base sm:text-lg text-sage leading-relaxed max-w-2xl mx-auto">
            Vos pieds vous portent toute la journée. Recevez gratuitement mon petit guide pour prendre un moment de détente et renouer avec votre corps, simplement, par les pieds.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-5 text-left">
          {POINTS.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-olive-border bg-beige-50 p-6" data-testid={`guide-point-${i}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <p.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <p className="mt-4 text-sm text-ink leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <NewsletterSignup source="page-guide" />

      <section className="px-6 pb-24 max-w-2xl mx-auto text-center">
        <p className="inline-flex items-center gap-2 text-sm text-sage">
          <Check className="w-4 h-4 text-olive" strokeWidth={2} /> Sans spam. Vous recevez aussi mes prochaines dates de formations et séjours.
        </p>
      </section>
    </div>
  );
}
